import { readonly, ref } from "vue";

const messages = ref([]);
let nextId = 1;
const allowedPositions = new Set(["center", "top", "right", "left"]);

function remove(id) {
  messages.value = messages.value.filter((item) => item.id !== id);
}

function show(message, options = {}) {
  if (!message) return null;

  const id = nextId++;
  const duration = Number(options.duration ?? 3200);
  const item = {
    id,
    type: options.type || "info",
    position: allowedPositions.has(options.position) ? options.position : "center",
    title: options.title || "",
    message: String(message)
  };

  messages.value = [...messages.value, item].slice(-4);
  if (duration > 0) {
    window.setTimeout(() => remove(id), duration);
  }
  return id;
}

const toast = {
  show,
  success(message, options = {}) {
    return show(message, { ...options, type: "success" });
  },
  error(message, options = {}) {
    return show(message, { ...options, type: "error", duration: options.duration ?? 4200 });
  },
  warning(message, options = {}) {
    return show(message, { ...options, type: "warning" });
  },
  info(message, options = {}) {
    return show(message, { ...options, type: "info" });
  },
  remove,
  clear() {
    messages.value = [];
  }
};

export function useToast() {
  return {
    messages: readonly(messages),
    toast
  };
}
